import PropTypes from "prop-types";
import { ReactComponent as FemaleIcon } from "../../../../assets/img/icon/female_black_24dp.svg";
import { ReactComponent as MaleIcon } from "../../../../assets/img/icon/male_black_24dp.svg";

const PatientInfo = ({ patient, className }) => {
  if (patient === undefined)
    return (
      <div
        className={`border border-primary shadow-lg rounded-lg px-2 md:px-4 py-2 md:py-4 animate-pulse flex space-x-3 ${className}`}
        id="patient-info"
      >
        <div className="rounded-full bg-primary h-12 w-12"></div>
        <div className="flex-1 space-y-2 py-1">
          <div className="h-4 bg-primary rounded w-5/6"></div>
          <div className="h-4 bg-primary rounded"></div>
        </div>
      </div>
    );
  return (
    <div
      className={`relative border border-primary shadow-lg rounded-lg px-2 md:px-4 py-2 md:py-3 ${className}`}
      id="patient-info"
    >
      <div className="flex justify-between relative">
        <div className="flex space-x-3 md:space-x-4 items-center py-1">
          <div className="w-12 h-12 flex-shrink-0 bg-primary rounded-full text-center">
            <span
              className=" text-white text-xl md:text-2xl uppercase"
              style={{ lineHeight: "3rem" }}
            >
              {patient.initial}
            </span>
          </div>
          <div className="">
            <div className="text-lg md:text-xl font-medium">{patient.name}</div>
            <div className="mt-0.5 md:mt-0 text-xs md:text-sm text-gray-800 text-opacity-50">
              {patient.profile.age ? `${patient.profile.age} Tahun |` : ""}
              {`
             ${patient.profile.weight || "-"} Kg |
            ${patient.profile.height || "-"} cm`}
            </div>
          </div>
        </div>
      </div>
      {patient.profile.isMale === true && (
        <div className="absolute right-1 md:right-2 top-4">
          <MaleIcon className="w-12 h-12 fill-current text-gray-500 text-opacity-50" />
        </div>
      )}
      {patient.profile.isMale === false && (
        <div className="absolute right-1 md:right-2 top-4">
          <FemaleIcon className="w-12 h-12 fill-current text-gray-500 text-opacity-50" />
        </div>
      )}
    </div>
  );
};

PatientInfo.propTypes = {
  className: PropTypes.string,
  patient: PropTypes.exact({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    initial: PropTypes.string.isRequired,
    profile: PropTypes.exact({
      age: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      dateOfBirth: PropTypes.string,
      height: PropTypes.number,
      isMale: PropTypes.bool,
      weight: PropTypes.number,
    }),
  }),
};
export default PatientInfo;
